import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchDividendDates } from '@apis/dividends';
import type { DividendDatesApiData } from '@app-types/dividendApi';
import { getAccessToken } from '@utils/authStorage';
import { getIframeQueryParamsFromSearch } from '@utils/queryParams';

/**
 * React Query hook for the related dividend schedule
 * (GET /api/dividends/dividend-dates). Reads ticker/mkt from the router location.
 */
export const useDividendDates = () => {
  const location = useLocation();
  const { ticker, mkt } = getIframeQueryParamsFromSearch(location.search);
  const hasToken = Boolean(getAccessToken());

  return useQuery<DividendDatesApiData>({
    queryKey: ['dividends', 'dividend-dates', ticker, mkt],
    queryFn: () => fetchDividendDates({ ticker: ticker as string, mkt: mkt as string }),
    enabled: Boolean(ticker && mkt && hasToken),
    staleTime: 60_000,
    retry: 1,
  });
};
